import type { NuxtError } from '#app'

type ParsedH3Error = {
  statusCode: number
  statusMessage?: string
  message?: string
  data?: unknown
  cause?: unknown
  isNuxtError: boolean
}

export function parseH3Error(raw: unknown): ParsedH3Error {
  const err = raw as Partial<NuxtError> & { statusCode?: number; data?: unknown; cause?: unknown }

  const statusCode =
    typeof err?.statusCode === 'number'
      ? err.statusCode
      : typeof (err as any)?.response?.status === 'number'
        ? (err as any).response.status
        : 500

  const statusMessage =
    (err as any)?.statusMessage ?? (err as any)?.response?.statusText ?? undefined

  const message = (err as any)?.message ?? (err as any)?.response?.data?.message ?? undefined

  let data: unknown = (err as any)?.data ?? (err as any)?.response?.data

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data)
    } catch {}
  }

  return {
    statusCode,
    statusMessage,
    message,
    data,
    cause: (err as any)?.cause,
    isNuxtError: !!(err as any)?.stack && 'statusCode' in (err as any),
  }
}
